(() => {
  const ADDON_VARIANT_ID = 50607630549298;
  const STORAGE_KEY = "pa_add_preview_after_cart";

  function isPreviewChecked() {
    const cb = document.querySelector("#preview-addon-checkbox");
    return !!cb && cb.checked;
  }

  function setPreviewFlag(val) {
    const flag = document.querySelector("#preview-requested-flag");
    if (flag) flag.value = val ? "Yes" : "No";
  }

  async function cartHasAddon() {
    const res = await fetch("/cart.js", { headers: { Accept: "application/json" } });
    if (!res.ok) return false;
    const cart = await res.json();
    return (cart.items || []).some((it) => Number(it.id) === Number(ADDON_VARIANT_ID));
  }

  async function addAddon() {
    const res = await fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({
        items: [
          {
            id: ADDON_VARIANT_ID,
            quantity: 1,
            properties: { _addon_for: "Design preview for main item" },
          },
        ],
      }),
    });
    return res.ok;
  }

  // 1) On product submit: don't block anything. Just set a flag for the cart page.
  document.addEventListener(
    "submit",
    (e) => {
      const form = e.target;
      if (!form?.matches?.('form[action^="/cart/add"]')) return;

      // Only if checkbox exists + checked
      if (!isPreviewChecked()) return;

      setPreviewFlag(true);

      // Tell the cart page to add the preview once
      sessionStorage.setItem(STORAGE_KEY, "1");
    },
    true
  );

  // 2) On cart page: if flag is set, add preview and refresh cart
  document.addEventListener("DOMContentLoaded", async () => {
    const onCartPage = location.pathname === "/cart";
    if (!onCartPage) return;

    if (sessionStorage.getItem(STORAGE_KEY) !== "1") return;

    // Clear immediately to avoid loops if anything fails
    sessionStorage.removeItem(STORAGE_KEY);

    try {
      // Avoid adding twice
      const alreadyThere = await cartHasAddon();
      if (!alreadyThere) {
        const ok = await addAddon();
        if (!ok) return;
      }

      // Refresh cart page so customer sees it
      location.reload();
    } catch (err) {
      console.warn("Preview add-on (cart page) error:", err);
    }
  });
})();
